import styled from 'styled-components'
import { BLACK, GRAYSCALE_400, NEUTRAL_100, GRADIENT_SELECTED, GRADIENT_SELECTED_OVERLAY, GRADIENT_UNSELECTED_OVERLAY } from '../../styles/colors'
import { GIVONIC, INTER } from '../../styles/fonts'

interface OuterContainerProps {
  $selected?: boolean
}

export const OuterContainer = styled.div<OuterContainerProps>`
  position: relative;
  padding: 2px;
  border-radius: 12px;
  background: ${props => props.$selected ? GRADIENT_SELECTED : NEUTRAL_100};
  width: 100%;
`

interface InnerContainerProps {
  $selected?: boolean
}

export const InnerContainer = styled.div<InnerContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${props => props.$selected ? GRADIENT_SELECTED_OVERLAY : GRADIENT_UNSELECTED_OVERLAY};
  border-radius: 10px;
  padding: 38px 16px 24px 16px;
  gap: 6px;
  position: relative;
`

export const RadioWrapper = styled.div`
  position: absolute;
  right: 6px;
  top: 6px;
`

export const IDRPriceText = styled.span`
  font-family: ${GIVONIC.bold};
  font-size: 18px;
  color: ${BLACK};
`

export const JIDRPriceText = styled.span`
  font-family: ${INTER.bold};
  font-size: 14px;
  color: ${GRAYSCALE_400};
`

export const JIDRLabel = styled.span`
  font-family: ${INTER.regular};
  font-size: 14px;
  color: ${GRAYSCALE_400};
`
